import { render, staticRenderFns } from "./dui-gallery.vue?vue&type=template&id=70158498&"
import script from "./dui-gallery.vue?vue&type=script&lang=js&"
export * from "./dui-gallery.vue?vue&type=script&lang=js&"
import style0 from "./dui-gallery.vue?vue&type=style&index=0&id=70158498&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports